
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[platform]/[synonym]/[app]",
      function () {
        return require("private-next-pages/[platform]/[synonym]/[app].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[platform]/[synonym]/[app]"])
      });
    }
  